// extracted by mini-css-extract-plugin
module.exports = {"profileHeader":"ProfileHeader_profileHeader__j4LpV"};